module.exports = __webpack_public_path__ + "static/flags/UZ-5723c0cb280beaf6b9e716299fe42b71.gif";